export default "__VITE_ASSET__C519sZDC__"